'use strict';

require('./app.restrictUi.less');

angular.module('app')

/**
 * Service used to hold information about UI filters, such as when advanced or developer modes are not enabled, to not show UI elements for advanced users or developers
 */
    .service('restrictUi', function (auth, $rootScope, DataEnvironmentService, authService) {

        let userTypes = {
            NORMAL: 'normal',
            ADVANCED: 'advanced',
            DEVELOPER: 'developer',
            DEBUG: 'debug'
        };

        let ownerLevels = {
            OWNER: 'owner',
            INTERNAL: 'internal',
            EXTERNAL: 'external',
        };

        let expertLevels = {
            NOVICE: 'novice',
            EXPERT: 'expert',
        };

        let featureStabilityLevels = {
            GENERAL_AVAILABILITY: 'general-availability',
            PUBLIC_BETA: 'public-beta',
            PRIVATE_BETA: 'private-beta',
            EXPERIMENTAL: 'experimental',
            INTERNAL: 'internal'
        };

        let sections = {
            ONBOARDING: 'onboarding',
            OWNER: 'owner',
            INOUTNEITHER: 'in-out-neither',
            OWNERCOMPENSATION: 'owner-compensation',
            VAT: 'vat',
            BOOKS: 'books',
            MISSIONS: 'missions',
            SHARE: 'share',
            ASSIST: 'assist',
            OUTSOURCE: 'outsource',
            TIME: 'time',
            HELP: 'help',
            DEBUG: 'debug',
        };

        let restrictUi = {
            userTypes: userTypes,
            currentUserType: userTypes.NORMAL,
            setUserType: function (ref) {
                this.currentUserType = ref;
            },
            byUserType: function (ref) {
                switch (ref) {
                    case userTypes.NORMAL:
                        return true;
                        break;
                    case userTypes.ADVANCED:
                        return (this.currentUserType == userTypes.DEBUG) || (this.currentUserType == userTypes.DEVELOPER) || (this.currentUserType == userTypes.ADVANCED);
                        break;
                    case userTypes.DEVELOPER:
                        return (this.currentUserType == userTypes.DEBUG) || (this.currentUserType == userTypes.DEVELOPER);
                        break;
                    case userTypes.DEBUG:
                        return this.currentUserType == userTypes.DEBUG;
                        break;
                }
                return false;
            },
            ownerLevels: ownerLevels,
            currentOwnerLevel: ownerLevels.EXTERNAL,
            setOwnerLevel: function (ref) {
                this.currentOwnerLevel = ref;
            },
            byOwnerLevel: function (ref) {
                switch (ref) {
                    case ownerLevels.EXTERNAL:
                        return true;
                        break;
                    case ownerLevels.INTERNAL:
                        return (this.currentOwnerLevel == ownerLevels.INTERNAL) || (this.currentOwnerLevel == ownerLevels.OWNER);
                        break;
                    case ownerLevels.OWNER:
                        return this.currentOwnerLevel == ownerLevels.OWNER;
                        break;
                }
                return false;
            },
            expertLevels: expertLevels,
            currentExpertLevel: expertLevels.NOVICE,
            setExpertLevel: function (ref) {
                this.currentExpertLevel = ref;
            },
            byExpertLevel: function (ref) {
                switch (ref) {
                    case expertLevels.NOVICE:
                        return true;
                        break;
                    case expertLevels.EXPERT:
                        return this.currentExpertLevel == expertLevels.EXPERT;
                        break;
                }
                return false;
            },
            // Feature-stability levels
            featureStabilityLevels: featureStabilityLevels,
            currentFeatureStabilityLevel: featureStabilityLevels.GENERAL_AVAILABILITY,
            setFeatureStabilityLevel: function (ref) {
                this.currentFeatureStabilityLevel = ref;
            },
            byFeatureStabilityLevel: function (ref) {
                switch (ref) {
                    case featureStabilityLevels.GENERAL_AVAILABILITY:
                        return true;
                        break;
                    case featureStabilityLevels.PUBLIC_BETA:
                        return (this.currentFeatureStabilityLevel == featureStabilityLevels.INTERNAL) || (this.currentFeatureStabilityLevel == featureStabilityLevels.EXPERIMENTAL) || (this.currentFeatureStabilityLevel == featureStabilityLevels.PRIVATE_BETA) || (this.currentFeatureStabilityLevel == featureStabilityLevels.PUBLIC_BETA);
                        break;
                    case featureStabilityLevels.PRIVATE_BETA:
                        return (this.currentFeatureStabilityLevel == featureStabilityLevels.INTERNAL) || (this.currentFeatureStabilityLevel == featureStabilityLevels.EXPERIMENTAL) || (this.currentFeatureStabilityLevel == featureStabilityLevels.PRIVATE_BETA);
                        break;
                    case featureStabilityLevels.EXPERIMENTAL:
                        return (this.currentFeatureStabilityLevel == featureStabilityLevels.INTERNAL) || (this.currentFeatureStabilityLevel == featureStabilityLevels.EXPERIMENTAL);
                        break;
                    case featureStabilityLevels.INTERNAL:
                        return this.currentFeatureStabilityLevel == featureStabilityLevels.INTERNAL;
                        break;
                }
                return false;
            },
            asPublicBetaFeature: function () {
                return this.byFeatureStabilityLevel(featureStabilityLevels.PUBLIC_BETA);
            },
            asPrivateBetaFeature: function () {
                return this.byFeatureStabilityLevel(featureStabilityLevels.PRIVATE_BETA);
            },
            asExperimentalFeature: function () {
                return this.byFeatureStabilityLevel(featureStabilityLevels.EXPERIMENTAL);
            },
            asInternalFeature: function () {
                return this.byFeatureStabilityLevel(featureStabilityLevels.INTERNAL);
            },
            // Sections
            sections: sections,
        };

        // The following method is dependent on auth profile promise, so we let a false-returning stub act
        // as the show-function until the profile is loaded
        restrictUi.showSection = function () {
            return false;
        };
        authService.authenticatedDefer.promise.then(function (profile) {
            restrictUi.showSection = function (ref) {

                let isAffirmative = function (value) {
                    return (value === 'yes') || (value === 'maybe');
                };

                // If there is no user_metadata, act as if no information has been given
                let user_metadata = {};
                if (profile.user_metadata) {
                    user_metadata = profile.user_metadata;
                }

                /*
                 <!-- reimbursements // [Money, Travel] -->
                 <!-- company_money_flows // [Money, Travel, Books, Recordkeeping, Share] -->
                 <!-- keep_authorities_happy // [Money, Travel, Books, Recordkeeping, Share] -->
                 <!-- assist_others // [Assist, Robo-advicing] -->
                 <!-- personal_money_flows // [Money] -->
                 <!-- time_reports // [Time]-->
                 */
                switch (ref) {
                    case sections.ONBOARDING:
                    case sections.HELP:
                        return true;
                        break;
                    case sections.OWNER:
                        return true;
                        /*
                        return isAffirmative(user_metadata.intent_reimbursements)
                            || isAffirmative(user_metadata.intent_company_money_flows)
                            || isAffirmative(user_metadata.intent_keep_authorities_happy)
                            || isAffirmative(user_metadata.intent_assist_others)
                            || isAffirmative(user_metadata.intent_personal_money_flows)
                            || isAffirmative(user_metadata.intent_time_reports);
                            */
                        break;
                    case sections.TIME:
                        if (!restrictUi.asExperimentalFeature()) {
                            return false;
                        }
                        return isAffirmative(user_metadata.intent_time_reports);
                        break;
                    case sections.INOUTNEITHER:
                        return isAffirmative(user_metadata.intent_reimbursements)
                            || isAffirmative(user_metadata.intent_company_money_flows)
                            || isAffirmative(user_metadata.intent_keep_authorities_happy)
                            || isAffirmative(user_metadata.intent_personal_money_flows);
                        break;
                    case sections.OWNERCOMPENSATION:
                        if (!restrictUi.asExperimentalFeature()) {
                            return false;
                        }
                        return isAffirmative(user_metadata.intent_reimbursements)
                            || isAffirmative(user_metadata.intent_personal_money_flows);
                        break;
                    case sections.VAT:
                        return isAffirmative(user_metadata.intent_company_money_flows)
                            || isAffirmative(user_metadata.intent_keep_authorities_happy);
                        break;
                    case sections.BOOKS:
                        return isAffirmative(user_metadata.intent_company_money_flows)
                            || isAffirmative(user_metadata.intent_keep_authorities_happy);
                        break;
                    case sections.MISSIONS:
                        return isAffirmative(user_metadata.intent_keep_authorities_happy);
                        break;
                        /*
                    case sections.TRAVEL:
                        return isAffirmative(user_metadata.intent_reimbursements)
                            || isAffirmative(user_metadata.intent_company_money_flows)
                            || isAffirmative(user_metadata.intent_keep_authorities_happy);
                        break;
                    case sections.RECORDS:
                        return isAffirmative(user_metadata.intent_company_money_flows)
                            || isAffirmative(user_metadata.intent_keep_authorities_happy);
                        break;
                        */
                    case sections.SHARE:
                        return isAffirmative(user_metadata.intent_keep_authorities_happy);
                        break;
                    case sections.OUTSOURCE:
                        return isAffirmative(user_metadata.intent_keep_authorities_happy);
                        break;
                    case sections.ASSIST:
                        return isAffirmative(user_metadata.intent_assist_others);
                        break;
                }
                return false;
            };
        });

        let restrictUiBasedOnUserProfile = function (event, profile) {

            // Set relevant beta channel
            if (profile.app_metadata.beta_channel) {
                restrictUi.setFeatureStabilityLevel(profile.app_metadata.beta_channel);
            } else {
                // If no channel is set but an active account is found, assume private beta for now
                DataEnvironmentService.activeDataEnvironment.promise.then(function () {
                    restrictUi.setFeatureStabilityLevel(featureStabilityLevels.PRIVATE_BETA);
                });
            }

        };

        // Listen to relevant events
        $rootScope.$on('authenticated', restrictUiBasedOnUserProfile);

        return restrictUi;

    })

    .component('viewsElementsRestrictUiSideMenuControls', {
        template: require('views/elements/restrict-ui-side-menu-controls.html'),
        controller: function ($scope, restrictUi) {
            $scope.restrictUi = restrictUi;
        },
    })
    .component('viewsElementsActiveAccountRequired', {
        template: require('views/elements/active-account-required.html'),
        controller: function ($scope, DataEnvironmentService) {
            $scope.dataEnvironments = DataEnvironmentService.dataEnvironments;
            $scope.activeDataEnvironment = DataEnvironmentService.activeDataEnvironment;
            $scope.setDataEnvironment = DataEnvironmentService.setDataEnvironment;
        },
    })
    .component('viewsElementsActiveAccountRequiredSideMenuNotice', {
        template: require('views/elements/active-account-required-side-menu-notice.html'),
        controller: function ($scope, DataEnvironmentService) {
            $scope.dataEnvironments = DataEnvironmentService.dataEnvironments;
            $scope.activeDataEnvironment = DataEnvironmentService.activeDataEnvironment;
            $scope.setDataEnvironment = DataEnvironmentService.setDataEnvironment;
        },
    })
    .component('notYetAvailable', {
        transclude: true,
        template: require('views/elements/not-yet-available.html'),
        controller: function ($scope, restrictUi) {
            $scope.restrictUi = restrictUi;
        },
    })
    .component('notYetFullyUsable', {
        transclude: true,
        template: require('views/elements/not-yet-fully-usable.html'),
        controller: function ($scope, restrictUi) {
            $scope.restrictUi = restrictUi;
        },
    })

;



// WEBPACK FOOTER //
// .-dna/app/scripts/app.restrictUi.js